import { render } from "../../views/forms/form_footer.html?vue&type=template&id=149d8a24&ts=true&external"
import script from "../../scripts/forms/form_footer.ts?vue&type=script&lang=ts&external"
export * from "../../scripts/forms/form_footer.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/forms/form_footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "149d8a24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('149d8a24', __exports__)) {
    api.reload('149d8a24', __exports__)
  }
  
  module.hot.accept("../../views/forms/form_footer.html?vue&type=template&id=149d8a24&ts=true&external", () => {
    api.rerender('149d8a24', render)
  })

}


export default __exports__